import { listPersonsTotals, PersonsTotalsData } from './listPersonsTotals'
import { listSchedules, SchedulesStatus, getListSchedules } from './listSchedules'
import { getScheduleAvailabilities } from './listScheduleAvailabilities'
import { getListSchedulesByStatus } from './listSchedulesByStatus'
import { getSchedulesAverage } from './listSchedulesAverage'
 
export default {
  getListSchedules,
  getScheduleAvailabilities,
  getListSchedulesByStatus,
  listPersonsTotals,
  listSchedules,
  getSchedulesAverage
}
export type { 
  PersonsTotalsData as IPersonsTotals,
  SchedulesStatus as ISchedules,
}